import { useContext } from 'react';
import { ZipLongDistanceConfirmContext } from 'site-modules/shared/components/lead-form/zip-long-distance-confirm/zip-long-distance-confirm-context';

export const useZipLongDistanceConfirm = () => {
  const { setZipLongDistanceConfirm, showZipLongDistanceConfirm } = useContext(ZipLongDistanceConfirmContext);

  return { setZipLongDistanceConfirm, showZipLongDistanceConfirm };
};
